import React from 'react';
import { modules, OFFER_ANCHOR } from '../data/product';
export function ModulesSection() {
  return <section className="bg-navy px-4 py-4 sm:py-6" data-id="element-96" data-mp="1nued3mybihmk">
      <div className="mx-auto max-w-4xl" data-id="element-97" data-mp="1nsl6u8rm9zf3">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-98" data-mp="1ius1fhy519fv">
          WHAT’S INCLUDED
        </h2>

        <div className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-99" data-mp="1dxt6wyakb0h5">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="flex flex-col rounded-md border border-white/15 bg-white/[0.04] p-2.5 transition-colors duration-150 hover:border-volt" data-id="element-100" data-mp="2bixo4a8r58ic">
              <p className="font-head text-[12px] font-bold uppercase tracking-wide text-volt" data-id="element-101" data-mp="21nvzrgmawagt">
                ✅ MODULE {module.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-white sm:text-lg" data-id="element-102" data-mp="q7yzwxcxc64t">
                {module.title}
              </h3>
              {module.body.map(paragraph => <p key={paragraph} className="mt-1 text-[13px] font-medium leading-snug text-white/80" data-id="element-103" data-mp="1iuz1ucq0vrzu">
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-1.5 font-head text-[13px] font-bold uppercase tracking-wide text-volt" data-id="element-104" data-mp="18w9jkiu7s5j2">
                {module.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}